(function () {
    'use strict';

    angular
        .module('app')
        .config([
            '$urlRouterProvider',
            '$httpProvider',
            '$uibModalProvider',
            '$uiViewScrollProvider',
            '$anchorScrollProvider',
            '$provide',
            'RestangularProvider',
            config
        ]);

    function config($urlRouterProvider, $httpProvider, $uibModalProvider, $uiViewScrollProvider, $anchorScrollProvider) {
        $httpProvider.interceptors.push('authInterceptorService');
        $anchorScrollProvider.disableAutoScrolling();
        $uiViewScrollProvider.useAnchorScroll();

        $uibModalProvider.options = {
            animation: false,
            size: 'md'
        };

        $httpProvider.interceptors.push(['$window', '$q', '$injector', function ($window, $q, $injector) {
            return {
                'responseError': function (rejection) {

                    switch (rejection.status) {
                        case 401:
                            $window.location = 'login';
                            return;
                        case 500:
                            $injector.get('toastr').error('An application exception occurred.');
                    }

                    return $q.reject(rejection);

                }
            };
        }]);
       
    };

})();